module.exports = __webpack_public_path__ + "static/media/house-gray.cb8bddef.svg";